export const weight = {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
};
export const fontWeight = (name) => `font-weight: ${weight[name] ? weight[name] : weight.normal};`;
